import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/core/services/config.service';
import { PortalMessage } from '../models/PortalMessage';
import { PortalMessageSearchResultItem } from '../models/PortalMessageSearchResultItem';
import { PortalMessageTemplateDictionaryDataItem } from '../models/PortalMessageTemplateDictionaryDataItem';
import { RecipientContactData } from '../models/RecipientContactData';
import { SearchPortalMessagesCriteria } from '../models/SearchPortalMessagesCriteria';
import { SearchPortalMessageThreadsCriteria } from '../models/SearchPortalMessageThreadsCriteria';
import { PortalMessageThreadSearchResultItem } from '../models/PortalMessageThreadSearchResultItem';
import { PortalMessageThread } from '../models/PortalMessageThread';
import { GetPortalMessagesForUserCriteria } from '../models/GetPortalMessagesForUserCriteria';
import { PortalMessageForUserResultItem } from '../models/PortalMessageForUserResultItem';
import { ConfirmReadingByRecipientData } from '../models/ConfirmReadingByRecipientData';
import { MarkAsReadByRecipientData } from '../models/MarkAsReadByRecipientData';
import { GetSentPortalMessagesByUserCriteria } from '../models/GetSentPortalMessagesByUserCriteria';
import { PortalMessageSentItem } from '../models/PortalMessageSentItem';
import { GetReceivedPortalMessagesByUserCriteria } from '../models/GetReceivedPortalMessagesByUserCriteria';
import { PortalMessageReceivedItem } from '../models/PortalMessageReceivedItem';


@Injectable({
  providedIn: 'root'
})
export class PortalMessageService {

 
  constructor(private http: HttpClient,
    private configService: ConfigService) {

  }

  public addMessage(data: PortalMessage): Observable<number> {
    return this.http.post<number>(
      this.configService.PortalWebApiUrl + 'PortalMessage', data);
  }

  public updateMessage(data: PortalMessage): Observable<number> {
    return this.http.put<number>(
      this.configService.PortalWebApiUrl + 'PortalMessage', data);
  }

  public getMessage(id: number): Observable<PortalMessage> {
    return this.http.get<PortalMessage>(
      this.configService.PortalWebApiUrl + 'PortalMessage/' + id);
  }

  public getRecipientData(claimIdentifier:string, roleId: number): Observable<RecipientContactData> {
    return this.http.get<RecipientContactData>(
      this.configService.PortalWebApiUrl + 'PortalMessage/recipientData/' + claimIdentifier + '/' + roleId);
  }

  public searchMessages(criteria: SearchPortalMessagesCriteria): Observable<PortalMessageSearchResultItem[]> {
    return this.http.post<PortalMessageSearchResultItem[]>(
      this.configService.PortalWebApiUrl + 'PortalMessage/search', criteria);
  }

  public getPortalMessageTemplates(sendingChannelType:number,claimIdentifier:string): Observable<PortalMessageTemplateDictionaryDataItem[]> {
      return this.http.get<PortalMessageTemplateDictionaryDataItem[]>(
        this.configService.PortalWebApiUrl + 'PortalMessage/PortalMessageTemplates/' +  sendingChannelType + '/' + claimIdentifier);
  }

  public searchPortalMessageThreads(criteria: SearchPortalMessageThreadsCriteria): Observable<PortalMessageThreadSearchResultItem[]> {
    return this.http.post<PortalMessageThreadSearchResultItem[]>(
      this.configService.PortalWebApiUrl + 'PortalMessage/messageThread/search', criteria);
  }

  public storeMessageThread(data: PortalMessageThread): Observable<number> {
    return this.http.post<number>(
      this.configService.PortalWebApiUrl + 'PortalMessage/messageThread/store', data);
  }

  public getThreadPortalMessages(threadId: string): Observable<PortalMessageSearchResultItem[]> {
    return this.http.get<PortalMessageSearchResultItem[]>(
      this.configService.PortalWebApiUrl + 'PortalMessage/threadMessages/' + threadId);
  }

  public getThreadPortalMessagesAllowedForUser(threadId: string): Observable<PortalMessageSearchResultItem[]> {
    return this.http.get<PortalMessageSearchResultItem[]>(
      this.configService.PortalWebApiUrl + 'PortalMessage/threadMessagesAllowedForUser/' + threadId);
  }

  public getPortalMessagesForUser(criteria: GetPortalMessagesForUserCriteria): Observable<PortalMessageForUserResultItem[]> {
    return this.http.post<PortalMessageForUserResultItem[]>(
      this.configService.PortalWebApiUrl + 'PortalMessage/getPortalMessagesForUser', criteria);
  }

  public confirmReading(data: ConfirmReadingByRecipientData): Observable<number> {
    return this.http.post<number>(
      this.configService.PortalWebApiUrl + 'PortalMessage/confirmReading', data);
  }

  public markAsReadByForSupplierParts(threadId: string): Observable<number> {
    return this.http.post<number>(
      this.configService.PortalWebApiUrl + 'PortalMessage/markAsReadByForSupplierParts', 
      JSON.stringify(threadId),
    { headers: { 'Content-Type': 'application/json' } });
  }

  public markAsRead(data: MarkAsReadByRecipientData): Observable<number> {
    return this.http.post<number>(
      this.configService.PortalWebApiUrl + 'PortalMessage/markAsRead', data);
  }

  public getSentPortalMessagesByUser(criteria: GetSentPortalMessagesByUserCriteria): Observable<PortalMessageSentItem[]> {
    return this.http.post<PortalMessageSentItem[]>(
      this.configService.PortalWebApiUrl + 'PortalMessage/getSentPortalMessagesByUser', criteria);
  }

  public getReceivedPortalMessagesByUser(criteria: GetReceivedPortalMessagesByUserCriteria): Observable<PortalMessageReceivedItem[]> {
    return this.http.post<PortalMessageReceivedItem[]>(
      this.configService.PortalWebApiUrl + 'PortalMessage/getReceivedPortalMessagesByUser', criteria);
  }

}
